import { useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { useLang } from "@/context/LangContext";
import Stamp from "@/components/Stamp";

const Community = () => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setDone(true);
  };

  return (
    <section id="join" className="bg-pink border-b border-ink py-20 md:py-28 relative overflow-hidden" data-testid="community">
      <div className="absolute top-8 right-8 md:right-20 hidden sm:block opacity-90">
        <Stamp size={110} bg="bg-lime" />
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center relative z-10">
        <p className="kicker text-cream/90">{t.communityKicker}</p>
        <h2 className="display uppercase text-5xl md:text-8xl leading-[0.84] mt-3 text-cream">
          {t.communityTitle}
        </h2>
        <p className="mt-4 text-cream/90 font-semibold text-lg max-w-lg mx-auto">{t.communitySub}</p>

        {done ? (
          <div className="mt-9 inline-flex items-center gap-3 bg-cream text-ink border border-ink rounded-full h-16 px-8 display uppercase text-xl" data-testid="join-success">
            <Check className="w-6 h-6" strokeWidth={2.5} /> {t.joined}
          </div>
        ) : (
          <form onSubmit={submit} className="mt-9 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto" data-testid="join-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t.emailPlaceholder}
              data-testid="join-email"
              className="flex-1 h-16 px-6 border border-ink bg-cream text-ink font-medium rounded-full placeholder:text-ink/40 focus:outline-none focus:ring-2 focus:ring-lime"
            />
            <button type="submit" data-testid="join-submit" className="btn bg-ink text-lime h-16 px-8 text-base hover:bg-cream hover:text-ink">
              {t.join} <ArrowRight className="w-5 h-5" strokeWidth={2} />
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default Community;
